/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/mapTo */
import{map as r}from"rxjs/dist/esm/internal/operators/map";function p(o){return r(()=>o)}export{p as mapTo};
//# sourceMappingURL=mapTo.mjs.map